import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, Calendar, Clock, Home } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BookingConfirmed = () => {
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.get('booking_id');
  const [booking, setBooking] = useState(null);

  useEffect(() => {
    if (bookingId) {
      axios.get(`${API}/bookings`).then(res => {
        const found = res.data.find(b => b.id === bookingId);
        if (found) setBooking(found);
      }).catch(() => {});
    }
  }, [bookingId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-sky-50 to-emerald-50 px-4" data-testid="booking-confirmed-page">
      <Card className="max-w-lg w-full text-center">
        <CardContent className="pt-8 pb-8">
          <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <CheckCircle className="h-8 w-8 text-emerald-600" />
          </div>
          <h1 className="text-2xl font-bold text-slate-900 mb-2">Booking Confirmed!</h1>
          <p className="text-slate-600 mb-6">
            Your deposit of £15.00 has been received. Your appointment is now confirmed.
          </p>

          {booking && (
            <div className="bg-slate-50 rounded-lg p-4 mb-6 text-left space-y-3">
              <div className="flex items-center gap-2 text-sm">
                <Calendar className="h-4 w-4 text-sky-600" />
                <span className="text-slate-700 font-medium">{booking.date}</span>
              </div>
              <div className="flex items-center gap-2 text-sm">
                <Clock className="h-4 w-4 text-sky-600" />
                <span className="text-slate-700 font-medium">{booking.timeSlot?.replace('-', ' - ')}</span>
              </div>
              <div className="text-sm">
                <span className="text-slate-500">Service: </span>
                <span className="text-slate-700 font-medium capitalize">{booking.serviceType?.replace('-', ' ')}</span>
              </div>
              <div className="text-sm">
                <span className="text-slate-500">Remaining balance: </span>
                <span className="text-slate-700 font-medium">£{(booking.totalAmount - 15).toFixed(2)} (due on completion)</span>
              </div>
            </div>
          )}

          <p className="text-sm text-slate-500 mb-6">
            You will receive a confirmation email shortly. If you need to reschedule, please contact us.
          </p>

          <Link to="/">
            <Button className="bg-sky-600 hover:bg-sky-700" data-testid="back-home-btn">
              <Home className="h-4 w-4 mr-2" /> Back to Home
            </Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
};

export default BookingConfirmed;
